import { DropdownLayout } from '../components';
import type { StyleProps } from './types';

export function Style11({ items, onClick }: StyleProps) {
  return (
    <DropdownLayout
      items={items}
      withFlag
      flagStyle="rounded"
      activeItemNameKey="codeName"
      onClick={onClick}
    />
  );
}
